import { infiniteQueryOptions } from "@tanstack/react-query";

import { useFetch } from "@/lib/axios.config";
import { PaginationResponse } from "@/shared/types/api.types";
import { Transaction } from "@/pages/history/types";
import { appConfig } from "@/lib/site-config";
import {
  getNextPageParam,
  getPreviousPageParam,
  initialPageParam,
} from "@/shared/utils/query";

export const useHistory = (type?: number | null) => {
  return infiniteQueryOptions({
    queryKey: ["transactions", type],
    queryFn: async ({ pageParam }) => {
      const params: Record<string, any> = {
        limit: appConfig.infiniteQueryLimit,
        offset: pageParam,
      };
      if (type !== null && type !== undefined) {
        params.type = type;
      }
      const response = await useFetch.get<
        PaginationResponse<Transaction>
      >("/wallet/TransactionList", { params });

      return response.data;
    },
    initialPageParam,
    getNextPageParam: getNextPageParam,
    getPreviousPageParam: getPreviousPageParam,
  });
};
